import SubtitleMenuItem from "./subtitle_menu_item";

export default class TrackSubtitleItem extends SubtitleMenuItem {
  constructor({ player, track } = {}) {
    super({player});
    this._track = track;
    this._kinds = ([this._track.kind]).filter(Boolean);
  }

  label() {
    return this.track().label;
  }

  track() {
    return this._track;
  }

  shouldBeActive() {
    return this._track.mode == "showing";
  }

  handleClick() {
    const subtitleItemClickEvent = new CustomEvent('subtitleTrackClick', { detail: this.track(), bubbles: true });
    this._el.dispatchEvent(subtitleItemClickEvent);
  }
}
